import classNames from 'classnames'
import { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'

import { selectIsQbrDocumentFinalized } from 'partner360/features/QBR'

import styles from './QBRSectionThatCanBeDisabled.module.scss'

interface IQBRSectionThatCanBeDisabled extends PropsWithChildren {}

export const QBRSectionThatCanBeDisabled = ({ children }: IQBRSectionThatCanBeDisabled) => {
  const isDocumentFinalized = useSelector(selectIsQbrDocumentFinalized)
  return <div className={classNames({ [styles.finalized]: isDocumentFinalized })}>{children}</div>
}
